<div class="container-fluid">
  <app-content-tab-list activeTab="3" type="marketplace" category="Marketplace"></app-content-tab-list>

  <div class="row section1 justify-content-between mt-4">
    <div class="col-12 col-md-auto">
      <div class="home-details">
        <h5 class="home-title">Requests ({{applications.length}})</h5>
        <p class="home-subtitle">Review and manage role applications from Bhakts</p>
      </div>
    </div>
    <div class="col-12 col-md-auto">
      <button class="btn btn-primary btn-dashboard" (click)="openManualAssignModal()">
        <i class="las la-user-plus"></i>Manual Add to Role
      </button>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="requests-filters-card">
        <div class="requests-filters-title">Filter Requests</div>
        <div class="requests-filters-grid">
          <div class="requests-filter-item requests-filter-item-wide">
            <label class="requests-filter-label">Keyword</label>
            <input type="text"
              class="form-control"
              [(ngModel)]="filters.keyword"
              (keydown)="handleFilterInputKeyDown($event)"
              placeholder="User, email, project, role, details"/>
          </div>
          <div class="requests-filter-item">
            <label class="requests-filter-label">Status</label>
            <select class="form-control" [(ngModel)]="filters.status">
              <option value="all">All</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>
          <div class="requests-filter-item">
            <label class="requests-filter-label">Type</label>
            <select class="form-control" [(ngModel)]="filters.itemType">
              <option value="all">All</option>
              <option value="project">Project</option>
              <option value="satire">Satire</option>
            </select>
          </div>
          <div class="requests-filter-actions">
            <button class="btn requests-filter-apply-btn ml-0" (click)="applyFilters()">Apply Filters</button>
            @if (hasActiveFilters()) {
              <button class="btn btn-outline-secondary ml-2" (click)="clearFilters()">Reset</button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <th scope="col">Request ID</th>
              <th scope="col">User</th>
              <th scope="col">Project</th>
              <th scope="col">Role</th>
              <th scope="col">Type</th>
              <th scope="col">Status</th>
              <th scope="col">Requested At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          @if (!loading && filteredApplications.length) {
            <tbody>
              @for (application of filteredApplications | paginate: { itemsPerPage: perPage, currentPage: page, totalItems: filteredApplications.length, id:'marketplace-project-applications'}; track application) {
                <tr class="client"
                  >
                  <td class="text-nowrap" [attr.title]="(application.id || '').toUpperCase()"><span>{{(application.id || '').slice(-6).toUpperCase()}}</span>
                  <i (click)="handleCopyToClipboard(application.id);" class="las la-copy la-lg pointer copy-icon"></i>
                </td>
                <td>
                  <div class="request-main">{{application.userName || 'NA'}}</div>
                  <div class="request-sub email-display">{{(application.email | lowercaseEmail) || 'NA'}}</div>
                </td>
                <td>
                  <div class="request-main">{{application.projectName || 'NA'}}</div>
                </td>
                <td>
                  <div class="request-main">{{application.roleName || 'NA'}}</div>
                </td>
                <td>
                  <span class="request-type text-capitalize">{{application.marketplaceItemType || 'project'}}</span>
                  <div class="request-sub mt-1 text-capitalize">{{(application.requestType || 'apply_role').replace('_', ' ')}}</div>
                  @if (application.requestDetails) {
                    <div class="request-sub mt-1">{{application.requestDetails}}</div>
                  }
                </td>
                <td>
                  <span class="request-status" [ngClass]="'status-' + (application.status || 'pending')">
                    {{application.status || 'pending'}}
                  </span>
                </td>
                <td>{{application.appliedAt | date:'medium'}}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect btn-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <a class="mr-3 text-primary py-2 text-nowrap">
                        View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                        @if (application.status !== 'approved') {
                          <a class="dropdown-item text-success border-bottom py-2 text-nowrap"
                            (click)="updateApplicationStatus(application, 'approved')">
                            <i class="las la-check-circle mb-1 la-lg align-middle mr-0"></i> Approve
                          </a>
                        }
                        @if (application.status !== 'rejected') {
                          <a class="dropdown-item text-danger border-bottom py-2 text-nowrap"
                            (click)="updateApplicationStatus(application, 'rejected')">
                            <i class="las la-times-circle mb-1 la-lg align-middle mr-0"></i> Reject
                          </a>
                        }
                      </div>
                    </div>
                    @if (actionLoadingId === application.id) {
                      <div class="request-inline-loader mt-2">Processing...</div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (loading) {
            <tbody>
              @for (q of loaders; track q) {
                <tr>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'160px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'180px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'180px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'180px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'140px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{height:'40px', width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader></td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
      @if (!loading && !filteredApplications.length) {
        <div class="d-flex align-items-center justify-content-center py-5">
          No requests found
        </div>
      }
      <div class="float-right mt-3">
        <pagination-controls (pageChange)="pageChange($event)" id="marketplace-project-applications"></pagination-controls>
      </div>
    </div>
  </div>
</div>

@if (showManualAssignModal) {
  <div class="modal fade show marketplace-manual-modal" tabindex="-1" role="dialog" [ngStyle]="{'display': 'block'}" (click)="closeManualAssignModal()">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content marketplace-manual-modal-content">
        <div class="modal-header marketplace-manual-modal-header">
          <h5 class="modal-title marketplace-manual-modal-title">Manual Add User To Role</h5>
          <button type="button" class="close marketplace-manual-close-btn" aria-label="Close" (click)="closeManualAssignModal()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body marketplace-manual-modal-body">
          <div class="row">
            <div class="col-12">
              <label class="manual-label">User ID <span>*</span></label>
              <input type="text" class="form-control" [(ngModel)]="manualForm.userId" placeholder="Enter user id">
            </div>
            <div class="col-12 col-md-6 mt-3">
              <label class="manual-label">Project <span>*</span></label>
              <select class="form-control"
                [(ngModel)]="manualForm.projectId"
                (ngModelChange)="updateAvailableRoles($event)">
                <option value="">Select project</option>
                @for (project of projects; track project) {
                  <option [value]="project.id">{{project.name}}</option>
                }
              </select>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <label class="manual-label">Role <span>*</span></label>
              <select class="form-control" [(ngModel)]="manualForm.roleId">
                <option value="">Select role</option>
                @for (role of availableRoles; track role) {
                  <option [value]="role.id">{{role.name}}</option>
                }
              </select>
            </div>
            <div class="col-12 mt-3">
              <label class="manual-label">Notes</label>
              <textarea class="form-control manual-notes-input"
                [(ngModel)]="manualForm.notes"
              placeholder="Optional notes for admin record"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer marketplace-manual-modal-footer">
          <button type="button" class="btn btn-outline-secondary" [disabled]="manualSaving" (click)="closeManualAssignModal()">Cancel</button>
          <button type="button" class="btn btn-primary btn-dashboard ml-0" [disabled]="manualSaving" (click)="saveManualAssignment()">
            {{manualSaving ? 'Saving...' : 'Add User To Role'}}
          </button>
        </div>
      </div>
    </div>
  </div>
}
@if (showManualAssignModal) {
  <div class="modal-backdrop fade show"></div>
}
